import React from 'react';
import classnames from 'classnames';
import getRenderable from '../../../lib/getRenderable';
import classes from './index.module.scss';
import { IconProps } from './types';

const getIconStyle = (size: number, color?: string) => ({
    width: `${size}px`,
    height: `${size}px`,
    fill: color
});

/**
 * @deprecated Please use any of layout components as a wrapper to icons from @fiverr-private/visuals package, usually Center is a good fit.
 */
const Icon = ({
    onClick,
    className: customClassName,
    color,
    children,
    size = 16,
    ariaLabel,
    buttonType
}: IconProps) => {
    const isOnClickValid = typeof onClick === 'function';
    const className = classnames(
        classes.fitIcon,
        {
            [classes.fitIconClickable]: isOnClickValid
        },
        customClassName
    );
    const iconStyle = getIconStyle(size, color);
    const ElementTag = isOnClickValid ? 'button' : 'span';
    const props = {
        className,
        style: iconStyle,
        'aria-label': ariaLabel
    };

    if (isOnClickValid) {
        Object.assign(props, { onClick, type: buttonType });
    } else if (ariaLabel) {
        Object.assign(props, { role: 'img' });
    } else {
        Object.assign(props, { 'aria-hidden': true });
    }

    return (
        <ElementTag {...props}>
            {getRenderable(children)}
        </ElementTag>
    );
};

Icon.displayName = 'Icon';

export default Icon;
